/** Explicit allowlist for the workshop-leader email campaign. Not a general promo field. */
export const WORKSHOP_LEADER_PROMO_CODE = 'LEADER50';
export const WORKSHOP_LEADER_CAMPAIGN = 'workshop-leader-2026q4';
export const WORKSHOP_LEADER_OFFER_STORAGE_KEY = 'mwp_workshop_leader_offer';

const ALLOWED_PROMO_CODES = new Set<string>([WORKSHOP_LEADER_PROMO_CODE]);

function searchParams(search: string): URLSearchParams {
  const query = search.startsWith('?') ? search.slice(1) : search;
  return new URLSearchParams(query);
}

export function isWorkshopLeaderOfferSearch(search: string): boolean {
  const params = searchParams(search);
  const promo = params.get('promo');
  if (promo !== null && ALLOWED_PROMO_CODES.has(promo)) return true;
  return params.get('utm_campaign') === WORKSHOP_LEADER_CAMPAIGN;
}

export function resolveWorkshopLeaderOffer(
  search: string,
  storage: Pick<Storage, 'getItem' | 'setItem'>,
): boolean {
  if (isWorkshopLeaderOfferSearch(search)) {
    try {
      storage.setItem(WORKSHOP_LEADER_OFFER_STORAGE_KEY, WORKSHOP_LEADER_PROMO_CODE);
    } catch {
      // sessionStorage can throw; the URL still qualifies this view.
    }
    return true;
  }

  try {
    return storage.getItem(WORKSHOP_LEADER_OFFER_STORAGE_KEY) === WORKSHOP_LEADER_PROMO_CODE;
  } catch {
    return false;
  }
}
